import { UATConstants } from 'src/Common/Models/UATConstants';

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { MANAGE_ACTION_CONSTANTS } from 'src/manageAction/utils/manageActionConstants';
import { keepUnusedDataForConfig } from 'src/Common/RTK/utils/store-constants';

export const artemisViewsApi = createApi({
  reducerPath: 'artemisViewsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: UATConstants.CommonServicesWebApiUrl,
    prepareHeaders: (headers) => {
      const token = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_API);
      const coreAPIToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_CORE_API);
      const graphToken = sessionStorage.getItem(MANAGE_ACTION_CONSTANTS.JWT_TOKEN_FOR_GRAPH);

      if (token && graphToken && coreAPIToken) {
        headers.set('Authorization', `Bearer ${token}`);
        headers.set('Coreapitoken', coreAPIToken);
        headers.set('Graphtoken', graphToken);
      } else {
        console.warn('One or more tokens are missing');
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getViewsArtemisLegacy: builder.query<any, any>({
      query: (data) => ({
        method: 'POST',
        url: UATConstants.ApiPaths.GetViewsArtemisLegacy,
        body: [data]
      }),
    }),
    getViewsArtemis: builder.query<any, any>({
      query: (tenantId) => ({
        method: 'GET',
        url: `${UATConstants.ApiPaths.GetViewsArtemis}?tenantid=${tenantId}`,
      }),
      keepUnusedDataFor: keepUnusedDataForConfig
    })
  }),
});

export const { useGetViewsArtemisLegacyQuery, useGetViewsArtemisQuery, useLazyGetViewsArtemisLegacyQuery, useLazyGetViewsArtemisQuery } = artemisViewsApi;
